module.exports = __webpack_public_path__ + "img/openarrow.d5742814.svg";